import React, { useEffect } from "react";
import {
  WagmiConfig,
  createConfig,
  http,
  useAccount,
  useSwitchChain,
} from "wagmi";
import {
  mainnet,
  sepolia,
  bsc,
  bscTestnet,
  Chain,
  baseSepolia,
  base,
} from "wagmi/chains";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConnectKitProvider, getDefaultConfig } from "connectkit";
import { DEFAULT_RPC, NET_ID } from "@/config";
import { useSelector } from "react-redux";

// 动态获取链配置
function getChains(): readonly [Chain, ...Chain[]] {
  if (NET_ID === mainnet.id) {
    return [mainnet] as const;
  }

  if (NET_ID === sepolia.id) {
    return [sepolia] as const;
  }

  if (NET_ID === bsc.id) {
    return [bsc] as const;
  }

  if (NET_ID === bscTestnet.id) {
    return [bscTestnet] as const;
  }

  if (NET_ID === baseSepolia.id) {
    return [baseSepolia] as const;
  }

  if (NET_ID === base.id) {
    return [base] as const;
  }

  return [mainnet, sepolia, bsc, bscTestnet, baseSepolia, base] as const; // 默认支持多个链
}

// console.log("NET_ID", NET_ID);
const chains = getChains();
export  const currentChain =chains[0]
// console.log("chains", chains);

// 创建 wagmi 配置
const config = createConfig(
  getDefaultConfig({
    appName: "eth tools",
    walletConnectProjectId: "630c648c23af10f1fe6798c3a8eb3e4e",
    chains: chains, // 仅配置与 NET_ID 匹配的链
    transports: {
      // [bsc.id]: http('https://bnb-mainnet.g.alchemy.com/v2/2US4SAiQQqFmQ5IR_oxnlyVveSqkGW9s'),
      // [bscTestnet.id]: http('https://bnb-testnet.g.alchemy.com/v2/2US4SAiQQqFmQ5IR_oxnlyVveSqkGW9s'),
      // [base.id]: http('https://base-mainnet.g.alchemy.com/v2/5j0pvtIddIgGqClo2FjxmIKRWt3BDyNe'), // base rpc节点
      // [baseSepolia.id]: http('https://base-sepolia.g.alchemy.com/v2/5j0pvtIddIgGqClo2FjxmIKRWt3BDyNe'), // base Sepolia测试网rpc节点
      // [mainnet.id]: http('https://eth-mainnet.g.alchemy.com/v2/5j0pvtIddIgGqClo2FjxmIKRWt3BDyNe'),
      // [sepolia.id]: http('https://eth-sepolia.g.alchemy.com/v2/5j0pvtIddIgGqClo2FjxmIKRWt3BDyNe'),
      [NET_ID]: http(DEFAULT_RPC),
    },
  })
);

const queryClient = new QueryClient();

// 自动切换到指定的默认链
// const AutoSwitchNetwork = () => {
//   const { chain } = useAccount(); // 获取当前链信息
//   const { switchChain } = useSwitchChain(); // 获取切换链的函数

//   useEffect(() => {
//     // 检查当前链与 NET_ID 是否匹配，如果不匹配则切换到正确的链
//     if (chain?.id !== NET_ID && switchChain) {
//       switchChain({ chainId: NET_ID }); // 自动切换到指定的网络
//     }
//   }, [chain, switchChain]);

//   return null; // 不需要渲染任何内容
// };

export const Web3Provider = ({ children }: { children: React.ReactNode }) => {
  // const { rpc } = useSelector((state: any) => state.projectControll);

  // const config = createConfig(
  //   getDefaultConfig({
  //     appName: 'eth tools',
  //     walletConnectProjectId: '630c648c23af10f1fe6798c3a8eb3e4e',
  //     chains: chains, // 仅配置与 NET_ID 匹配的链
  //     transports: {
  //       [NET_ID]: http(rpc)
  //     }
  //   })
  // );

  // useEffect(()=>{
  //   console.log("Web3Provider rpc change");
  // }, [rpc])

  return (
    <WagmiConfig config={config}>
      <QueryClientProvider client={queryClient}>
        <ConnectKitProvider debugMode mode="dark">
          {children}
        </ConnectKitProvider>
      </QueryClientProvider>
    </WagmiConfig>
  );
};
